"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThumbnailBase = exports.Remaining = exports.PlayIcon = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var ThumbnailBase = _styledComponents["default"].div.withConfig({
  displayName: "Thumbnailstyles__ThumbnailBase",
  componentId: "sc-kgo005-0"
})(["", " position:relative;box-sizing:border-box;cursor:pointer;&:hover{", "}img{display:block;max-width:100%;}", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["v-base ma0 pa0 ", ""])), function (_ref) {
  var _theme$gallery, _theme$gallery$thumbn;

  var theme = _ref.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$gallery = theme.gallery) === null || _theme$gallery === void 0 ? void 0 : (_theme$gallery$thumbn = _theme$gallery.thumbnail) === null || _theme$gallery$thumbn === void 0 ? void 0 : _theme$gallery$thumbn.base;
}), (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (_ref2) {
  var _theme$gallery2, _theme$gallery2$thumb;

  var theme = _ref2.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$gallery2 = theme.gallery) === null || _theme$gallery2 === void 0 ? void 0 : (_theme$gallery2$thumb = _theme$gallery2.thumbnail) === null || _theme$gallery2$thumb === void 0 ? void 0 : _theme$gallery2$thumb.hover;
}), function (_ref3) {
  var _theme$gallery3, _theme$gallery3$thumb, _theme$gallery3$thumb2, _theme$gallery4, _theme$gallery4$thumb, _theme$gallery4$thumb2;

  var selected = _ref3.selected,
      theme = _ref3.theme;
  return selected && (theme === null || theme === void 0 ? void 0 : (_theme$gallery3 = theme.gallery) === null || _theme$gallery3 === void 0 ? void 0 : (_theme$gallery3$thumb = _theme$gallery3.thumbnail) === null || _theme$gallery3$thumb === void 0 ? void 0 : (_theme$gallery3$thumb2 = _theme$gallery3$thumb.selected) === null || _theme$gallery3$thumb2 === void 0 ? void 0 : _theme$gallery3$thumb2.overlay) && "\n    &::after {\n      position: absolute;\n      left: 0;\n      top: 0;\n      right: 0;\n      bottom: 0;\n      content: '';\n      pointer-events: none;\n      background: ".concat(theme === null || theme === void 0 ? void 0 : (_theme$gallery4 = theme.gallery) === null || _theme$gallery4 === void 0 ? void 0 : (_theme$gallery4$thumb = _theme$gallery4.thumbnail) === null || _theme$gallery4$thumb === void 0 ? void 0 : (_theme$gallery4$thumb2 = _theme$gallery4$thumb.selected) === null || _theme$gallery4$thumb2 === void 0 ? void 0 : _theme$gallery4$thumb2.overlay, ";\n    }\n  ");
});

exports.ThumbnailBase = ThumbnailBase;

var PlayIcon = _styledComponents["default"].span.withConfig({
  displayName: "Thumbnailstyles__PlayIcon",
  componentId: "sc-kgo005-1"
})(["", " & > i{width:1.75em;}"], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["absolute top-0 left-0 right-0 bottom-0 z-2 ", ""])), function (_ref4) {
  var _theme$gallery5, _theme$gallery5$thumb, _theme$gallery5$thumb2;

  var theme = _ref4.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$gallery5 = theme.gallery) === null || _theme$gallery5 === void 0 ? void 0 : (_theme$gallery5$thumb = _theme$gallery5.thumbnail) === null || _theme$gallery5$thumb === void 0 ? void 0 : (_theme$gallery5$thumb2 = _theme$gallery5$thumb.video) === null || _theme$gallery5$thumb2 === void 0 ? void 0 : _theme$gallery5$thumb2.container;
}));

exports.PlayIcon = PlayIcon;

var Remaining = _styledComponents["default"].div.withConfig({
  displayName: "Thumbnailstyles__Remaining",
  componentId: "sc-kgo005-2"
})(["", ""], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n    w-100 h-100 flex flex-column justify-center tc absolute top-0 left-0 z-4 \n    ", "\n  "])), function (_ref5) {
  var _theme$gallery6, _theme$gallery6$thumb, _theme$gallery6$thumb2;

  var theme = _ref5.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$gallery6 = theme.gallery) === null || _theme$gallery6 === void 0 ? void 0 : (_theme$gallery6$thumb = _theme$gallery6.thumbnail) === null || _theme$gallery6$thumb === void 0 ? void 0 : (_theme$gallery6$thumb2 = _theme$gallery6$thumb.remaining) === null || _theme$gallery6$thumb2 === void 0 ? void 0 : _theme$gallery6$thumb2.container;
}));

exports.Remaining = Remaining;